import { render } from "./InventoryItemsReports.vue?vue&type=template&id=0812c7df&ts=true"
import script from "./InventoryItemsReports.vue?vue&type=script&lang=ts"
export * from "./InventoryItemsReports.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__